import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { CYCNavigation } from "./CYCNavigation";
import { ProgramProvider } from "@/context/ProgramContext";

const CYCLayoutInternal = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <CYCNavigation />
      <Box component="main">
        <Container
          maxWidth="xl"
          sx={{ mt: isMobile ? 0 : 9, mb: isMobile ? 8 : 4 }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export const CYCLayout = () => (
  <ProgramProvider>
    <CYCLayoutInternal>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </CYCLayoutInternal>
  </ProgramProvider>
);
